// Copyright (c) Microsoft. All rights reserved.

import * as signalR from "@microsoft/signalr";

const signalRHubConnection = (baseUrl: string) => {
  const connectionHubUrl = new URL(baseUrl + "/chatHub");
  return new signalR.HubConnectionBuilder()
    .withUrl(connectionHubUrl.toString(), {
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets,
    })
    .build();
};

export default signalRHubConnection;
